import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop'
import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatSlideToggleChange } from '@angular/material/slide-toggle'
import { BlockDataService } from 'src/app/block-services/block-data.service'
import { BlockFieldsService } from 'src/app/block-services/block-fields.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { HelpersService } from 'src/app/helpers.service'
import { MixpanelService } from 'src/app/tracking/mixpanel.service'

@Component({
  selector: 'block-section',
  templateUrl: './block-section.component.html',
  styleUrls: ['./block-section.component.scss']
})
export class BlockSectionComponent implements OnInit {
  previewBlock = false
  styleFields = false
  blockData: any

  previewFields = false

  blockFields: any

  blockId = this.blockDataService.getUniqueId(2)
  twocol: boolean
  public sectionColumns = new FormControl()
  public sectionStyleForm = new FormControl()
  @Input() importedBlockData: any
  @Input() builderType: 'mobile' | 'website' = 'mobile' // Default to mobile for backward compatibility
  sectionFullWidth = false
  constructor(
    private blockDataService: BlockDataService,
    private blockFieldsService: BlockFieldsService,
    private helpers: HelpersService,
    public builderService: BuilderService,
    private mixPanel: MixpanelService
  ) {
    this.blockData = this.importedBlockData ? this.importedBlockData : this.blockFieldsService.getSectionBlockFields()
    this.twocol = false
  }

  ngOnInit(): void {
    if (this.importedBlockData) {
      this.previewBlock = true
      this.previewFields = false
      this.styleFields = false
      // Use the imported block's ID if it exists
      if (this.importedBlockData.id) {
        this.blockId = this.importedBlockData.id
      }
    }

    if (document.querySelector('video')) {
      document.querySelector('video')?.play()
    }
  }

  /**
   * Appends Block to the Preview, Initial checks if the block is added as initial block addition or appended live
   */
  addBlockToPreview(initial: any = '') {
    let blockSectionData = {
      component: BlockSectionComponent,
      index: 'latest',
      element: this,
      initial: initial
    }
    this.blockDataService.sendBlockData(blockSectionData)
    this.builderService.blocksCollapsed = true
  }

  appendBlock() {
    let sectionBlockData = {
      id: 0,
      type: 'section',
      style: {},
      elements: [
        {
          elType: 'column',
          elements: [],
          data: {},
          style: {},
          settings: {
            _column_size: 100
          }
        }
      ]
    }
    if (this.builderService.getTour()) {
      this.builderService.onboardingBlockAdded = true
    }
    this.blockId = this.blockDataService.appendBlocksData(sectionBlockData)
    this.addBlockToPreview()
    this.builderService.logData('Section Block Added', 'Block Add', 'Section Block Added').subscribe(
      (response) => {},
      (err) => {}
    )
    this.mixPanel.track('Block Added', {
      projectid: this.builderService.getSelectedProject(),
      block: 'section'
    })
  }

  /**
   * get all the image block fields from the service and adjust the src only
   * @param $event change event on the input field
   */
  sectionColumnsChange(blockId: any) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let sectionBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...sectionBlockFields.data }
    clonedBlockFieldsData.columns = this.sectionColumns.value
    sectionBlockFields.data = clonedBlockFieldsData
    /**
     * for multiple columns we have to add the column structure and adjust the column size
     */
    let allblocksdata = this.blockDataService.getAllBlocksData()
    const numColumns = parseInt(clonedBlockFieldsData.columns) || 1

    if (numColumns === 4) {
      // Add columns if they don't exist
      while (sectionBlockFields.elements.length < 4) {
        sectionBlockFields.elements.push(this.helpers.cloneObject(this.blockFieldsService.columnBlockData))
      }
      // Set column sizes to 25% each
      for (let i = 0; i < 4; i++) {
        sectionBlockFields.elements[i].settings = { _column_size: 25 }
      }
    } else if (numColumns === 3) {
      // Add columns if they don't exist
      while (sectionBlockFields.elements.length < 3) {
        sectionBlockFields.elements.push(this.helpers.cloneObject(this.blockFieldsService.columnBlockData))
      }
      // Remove extra columns
      while (sectionBlockFields.elements.length > 3) {
        sectionBlockFields.elements.pop()
      }
      // Set column sizes to ~33% each
      for (let i = 0; i < 3; i++) {
        sectionBlockFields.elements[i].settings = { _column_size: 33.33 }
      }
    } else if (numColumns === 2) {
      // If there is no Second Column add it
      if (!sectionBlockFields.elements[1]) {
        sectionBlockFields.elements.push(this.helpers.cloneObject(this.blockFieldsService.columnBlockData))
      }
      // Remove extra columns
      while (sectionBlockFields.elements.length > 2) {
        sectionBlockFields.elements.pop()
      }
      // Make the Column size 50 for both of them
      sectionBlockFields.elements[0].settings = { _column_size: 50 }
      sectionBlockFields.elements[1].settings = { _column_size: 50 }
    } else if (numColumns === 1) {
      // Remove extra columns
      while (sectionBlockFields.elements.length > 1) {
        sectionBlockFields.elements.pop()
      }
      // Make the Column Size 100
      sectionBlockFields.elements[0].settings._column_size = 100
    }
  }

  /**
   * Get the columns Number
   * @param blockId
   * @returns
   */
  columnsNumber(blockId: any) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return 1
    }
    const columns = this.getBlockFields(blockId).data?.columns
    if (columns === '4') {
      return 4
    }
    if (columns === '3') {
      return 3
    }
    if (columns === '2') {
      return 2
    }
    return 1
  }

  /**
   * Sync the clicked block on click inside the mobile preview
   */
  showData(blockId: any) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      // show data of the last element instead
      blockId = this.blockDataService.getLatestBlockId()
    }
    this.blockFieldsService.clickedBlockId = blockId
    this.blockDataService.sendCurrentBlock(BlockSectionComponent)
  }

  styleChange(style: any, blockId: any, $event: any, type: string) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    /**
     * Modifying Nested Object Directly won't work, so we have to clone the data object first then modify it
     */
    let itemBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    let clonedBlockFieldsData = { ...itemBlockFields.style }
    let data = ''
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value
    } else if (type == 'slider') {
      data = $event.currentTarget.value + 'px'
    }

    clonedBlockFieldsData[style] = data
    itemBlockFields.style = clonedBlockFieldsData
    switch (style) {
      case 'sectionBackground':
        let backgroundValue = $event.currentTarget.value
        if (backgroundValue.startsWith('http')) {
          clonedBlockFieldsData.background = 'url("' + backgroundValue + '")'
          itemBlockFields.style = clonedBlockFieldsData
        } else {
          clonedBlockFieldsData.background = backgroundValue
          itemBlockFields.style = clonedBlockFieldsData
        }

        break
      case 'firstColumnBackground':
        let colBackgroundValue = $event.currentTarget.value
        if (colBackgroundValue.startsWith('http')) {
          itemBlockFields.elements[0].style.background = 'url("' + colBackgroundValue + '")'
        } else {
          itemBlockFields.elements[0].style.background = colBackgroundValue
        }

        break
      case 'section_height_auto':
        if (data == 'yes') {
          clonedBlockFieldsData['height'] = 'auto'
          itemBlockFields.style = clonedBlockFieldsData
        }

        break
      default:
        break
    }
    return
  }

  getSectionBackgroundImage = (blockId: any) => {
    let sectionBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    if (sectionBlockFields.style?.backgroundImg) {
      return { background: 'url("' + sectionBlockFields.style.backgroundImg + '")' }
    }
    return {}
  }
  /**
   * Gets the status of the full width section
   *
   */
  getSectionWidth = (blockId: any) => {
    let sectionBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    if (sectionBlockFields.sectionFullWidth) {
      return true
    }
    return false
  }

  sectionWidthChange = (blockId: any, value: MatSlideToggleChange) => {
    let sectionBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    sectionBlockFields.sectionFullWidth = value.checked
  }

  sectionFullScreenChange = (blockId: any, value: MatSlideToggleChange) => {
    let sectionBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    sectionBlockFields.style.sectionFullScreen = value.checked
  }

  processBackgroundFile(fileInput: any, blockId: string) {
    const file: File = fileInput.target.files[0]
    this.builderService.showSettingsProgress = true
    if (this.builderService.standalone) {
      this.builderService.uploadImage(file, this.builderService.selectedProject, 'custom-images')?.subscribe((response) => {
        this.builderService.showSettingsProgress = false
        let sectionBlockFields = this.blockDataService.getSelectedBlockData(blockId)
        let clonedBlockFieldsData = { ...sectionBlockFields.style }
        clonedBlockFieldsData.background = 'url("' + response + '")'
        clonedBlockFieldsData.sectionBackgroundImage = response
        sectionBlockFields.style = clonedBlockFieldsData
      })
    } else {
      const reader = new FileReader()
      reader.addEventListener('load', (event: any) => {
        this.builderService.uploadFileCustomerServer(file, this.builderService.selectedProject, '').subscribe(
          (res) => {
            this.builderService.showSettingsProgress = false
            let sectionBlockFields = this.blockDataService.getSelectedBlockData(blockId)
            let clonedBlockFieldsData = { ...sectionBlockFields.style }
            clonedBlockFieldsData.background = 'url("' + res + '")'
            clonedBlockFieldsData.sectionBackgroundImage = res
            sectionBlockFields.style = clonedBlockFieldsData
          },
          (err) => {
            this.builderService.showSettingsProgress = false
            alert('error uploading file, please contact support')
          }
        )
      })
      reader.readAsDataURL(file)
    }
  }

  /**
   * Controls the number of columns inside the section
   */
  // sectionColumns = ( $event: any ) => {
  //   // if( $event.value === '2' ) {
  //   //   this.twocol = true;
  //   // }
  //   this.twocol = true;
  // }

  getBlockFields = (id: any) => {
    if (this.importedBlockData) {
      return this.importedBlockData
    }
    return this.blockDataService.getSelectedBlockData(id)
  }

  showStyleTab = () => {
    this.previewBlock = false
    this.previewFields = false
    this.styleFields = true
  }

  showDataTab = () => {
    this.previewBlock = false
    this.previewFields = true
    this.styleFields = false
  }

  checkSidebar = () => {
    if (!this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkPreview = () => {
    if (this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkData = () => {
    if (this.previewFields) {
      return true
    }
    return false
  }

  checkStyle = () => {
    if (this.styleFields && !this.previewFields && !this.previewBlock) {
      return true
    }
    return false
  }

  checkSettings = () => {
    if (!this.checkSidebar() && !this.checkPreview()) {
      return true
    }
    return false
  }

  /**
   * Deletes the Block from the mobile Preview
   * Deletes the Block from the JSON Object
   */
  deleteBlock = (blockId: any) => {
    let element = document.getElementById('column' + blockId + 'a')
    element?.closest('.stacksBlockContainer')?.parentElement?.remove()
    this.blockDataService.removeBlockData(blockId)
  }

  dropped(event: CdkDragDrop<string[]>) {
    /**
     *    event.container is the section
     *    event.previousContainer is the mobile preview
     *    event.item is the item being dragged
     * 
    console.log("We dragged an ");
    console.log(item.element.nativeElement);
    console.log(" from container column ");
    console.log(item.element.nativeElement.parentElement?.classList.contains('columnBlockContainer'));
    console.log(" to container ");
    console.log(container.element.nativeElement );
     **/

    const { previousContainer, container, item, previousIndex, currentIndex } = event
    // console.log(item.element.nativeElement);
    // console.log(" from container column ? ");
    // console.log( item.element.nativeElement.closest('.columnBlockContainer') );
    // console.log(" to container ");
    // console.log(container.element.nativeElement);
    // console.log(" in second column ? ");
    // console.log(container.element.nativeElement.classList.contains("secondColumn"));
    // Determine which column is being dropped into
    let droppedColumn = 0
    if (container.element.nativeElement.classList.contains('secondColumn')) {
      droppedColumn = 1
    } else if (container.element.nativeElement.classList.contains('thirdColumn')) {
      droppedColumn = 2
    } else if (container.element.nativeElement.classList.contains('fourthColumn')) {
      droppedColumn = 3
    }
    /**
     * Check if Section inside Section
     */
    if (item.element.nativeElement.classList.contains('previewSection') && container.element.nativeElement.classList.contains('columnBlockContainer')) {
      alert("Can't Drag section inside Section")
      return
    }

    /**
     * Check if moving from inside the Column itself
     */
    if (item.element.nativeElement.closest('.columnBlockContainer')) {
      let Container = container.element.nativeElement
      let containerId: any = Container.getAttribute('blockid')
      let allblocksdata = this.blockDataService.getAllBlocksData()
      for (const key in allblocksdata) {
        if (Object.prototype.hasOwnProperty.call(allblocksdata, key)) {
          const element = allblocksdata[key]
          if (element.id == containerId) {
            containerId = key
          }
        }
      }
      /**
       * Adjust the block data JSON Object
       */
      if (!allblocksdata[containerId].elements[droppedColumn]) {
        allblocksdata[containerId].elements.push(this.blockFieldsService.columnBlockData)
      }
      moveItemInArray(allblocksdata[containerId].elements[droppedColumn].elements, event.previousIndex + 1, event.currentIndex + 1)
      /**
       * Adjust the preview inside the Mobile Preview
       */

      /**
       * After Nested Elements the event.previousIndex is wrongly calculated as it counts the nested blocks as well, to avoid this confusion we have to count the nodes manually
       */
      let newPreviousIndex = 0
      let itemId = item.element.nativeElement.getAttribute('id')
      if (document.querySelector('#' + itemId)?.closest('.stacksBlockContainer')?.parentNode?.parentNode) {
        let allNodesOfSelectedItem = document.querySelector('#' + itemId)?.parentNode?.parentNode?.parentNode?.childNodes
        let currentNode = document.querySelector('#' + itemId)?.parentNode?.parentNode
        newPreviousIndex = Array.prototype.indexOf.call(allNodesOfSelectedItem, currentNode)
      }
      /**
       * After Nested Elements the event.currentIndex is wrongly calculated, to avoid this confusion we have to count the nodes manually through the placeholder
       */
      // let newCurrentIndex = 0;
      // if (document.querySelector(".blockPlaceholder")?.parentNode) {
      //   let allNodesOfSelectedItem = document.querySelector(".blockPlaceholder")?.parentNode?.childNodes;
      //   let currentNode = document.querySelector(".blockPlaceholder")?.parentNode;
      //   newCurrentIndex = Array.prototype.indexOf.call(allNodesOfSelectedItem, currentNode) - 1; // -1 to subtract the index of the placeholder itself
      // }
      // console.log(newCurrentIndex);
      let newCurrentIndex = currentIndex
      moveWithinContainer(container.element.nativeElement, event.previousIndex + 1, event.currentIndex + 1)
    } else {
      /**
       * Moving from outside to inside the section
       */
      let Container = container.element.nativeElement
      let containerId: any = Container.getAttribute('blockid')
      let allblocksdata = this.blockDataService.getAllBlocksData()

      // Find the section's index in the blocks array
      let sectionIndex: any = containerId
      for (const key in allblocksdata) {
        if (Object.prototype.hasOwnProperty.call(allblocksdata, key)) {
          const element = allblocksdata[key]
          if (element.id == containerId) {
            sectionIndex = parseInt(key)
          }
        }
      }

      // Ensure the column exists
      if (!allblocksdata[sectionIndex].elements[droppedColumn]) {
        allblocksdata[sectionIndex].elements.push(this.helpers.cloneObject(this.blockFieldsService.columnBlockData))
      }

      if (this.builderType === 'website') {
        // Website builder: use cdkDragData to get the block being dragged
        const draggedBlockData = item.data
        console.log('Website builder drop - draggedBlockData:', draggedBlockData)
        console.log('Section index:', sectionIndex, 'Container ID:', containerId)

        // Handle both cases: draggedBlockData can be the full object or just the ID string
        let blockId: any
        if (draggedBlockData && typeof draggedBlockData === 'object' && draggedBlockData.id !== undefined) {
          blockId = draggedBlockData.id
        } else if (draggedBlockData) {
          // draggedBlockData is just the ID string
          blockId = draggedBlockData
        }

        console.log('Block ID to find:', blockId)

        if (blockId !== undefined) {
          // Find and remove the block from the root blocksData array using loose equality for ID comparison
          const blockIndex = allblocksdata.findIndex((block: any) => block.id == blockId)
          console.log('Block index found:', blockIndex)

          if (blockIndex !== -1 && blockIndex !== sectionIndex) {
            // Calculate the adjusted section index after removal
            const adjustedSectionIndex = sectionIndex > blockIndex ? sectionIndex - 1 : sectionIndex
            console.log('Adjusted section index:', adjustedSectionIndex)

            // Remove from root array
            const [removedBlock] = allblocksdata.splice(blockIndex, 1)
            console.log('Removed block:', removedBlock)

            // Ensure section still exists and has elements array
            if (allblocksdata[adjustedSectionIndex] && allblocksdata[adjustedSectionIndex].elements) {
              // Ensure the column exists
              if (!allblocksdata[adjustedSectionIndex].elements[droppedColumn]) {
                allblocksdata[adjustedSectionIndex].elements[droppedColumn] = this.helpers.cloneObject(this.blockFieldsService.columnBlockData)
              }
              // Add to section column
              allblocksdata[adjustedSectionIndex].elements[droppedColumn].elements.push(removedBlock)
              console.log('Block added to section column:', droppedColumn)
            }
          }
          // Trigger change detection
          this.blockDataService.blocksData = [...this.blockDataService.blocksData]
        } else {
          console.log('No valid block ID found')
        }
      } else {
        // Mobile builder: use DOM-based index calculation
        let newPreviousIndex = 0
        let itemId = item.element.nativeElement.getAttribute('id')
        if (document.querySelector('#' + itemId)?.closest('.stacksBlockContainer')?.parentNode?.parentNode) {
          let allNodesOfSelectedItem = document.querySelector('#' + itemId)?.parentNode?.parentNode?.parentNode?.childNodes
          let currentNode = document.querySelector('#' + itemId)?.parentNode?.parentNode
          newPreviousIndex = Array.prototype.indexOf.call(allNodesOfSelectedItem, currentNode) - 1
        }
        let Item = item.element.nativeElement.parentNode?.parentNode
        if (Item) {
          document.querySelector('#mainMobileAppPreview > .ng-star-inserted > .stacksBlockContainer > #' + itemId)?.parentElement?.parentElement?.remove()
          this.blockDataService.builderBlocksIndex++
        }

        transferArrayItem(allblocksdata, allblocksdata[sectionIndex].elements[droppedColumn].elements, newPreviousIndex, allblocksdata[sectionIndex].elements[droppedColumn].elements.length)
      }
    }
  }
}

function moveWithinContainer(container: any, fromIndex: any, toIndex: any) {
  if (fromIndex === toIndex) {
    return
  }
  const nodeToMove = container.children[fromIndex]
  const targetNode = container.children[toIndex]
  // console.log("node to move",nodeToMove);
  // console.log("target node", targetNode);
  // console.log("from index", fromIndex);
  // console.log("to index", toIndex);
  // console.log("container children", container.children);
  if (fromIndex < toIndex) {
    targetNode.parentNode.insertBefore(nodeToMove, targetNode.nextSibling)
  } else {
    targetNode.parentNode.insertBefore(nodeToMove, targetNode)
  }
}
